import $ from 'jquery';

$(document).ready(function () {
    const storageKey = 'tvd_favorites';
    let favorites = JSON.parse(localStorage.getItem(storageKey) || '[]');

    function updateButton() {
        const $button = $(this);
        const id = String($button.data('id'));
        $button.toggleClass('active', favorites.includes(id));
        $button.attr('title', $button.data(favorites.includes(id) ? 'title-remove' : 'title-add'));
    }

    $('[class*="__likeButton"]').each(updateButton);

    $(document).on('click', '[class*="__likeButton"]', function (e) {
        e.preventDefault();
        const $button = $(this);
        const id = String($button.data('id'));
        favorites = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (favorites.includes(id)) {
            favorites = favorites.filter(item => item !== id);
        } else {
            favorites.push(id);
        }
        updateButton.call(this);
        localStorage.setItem(storageKey, JSON.stringify(favorites));

        if ($('.favouritesListing').length) {
            $button.parents('.listing__item').remove();
        }
    });


    $('.favouritesListing').each(function (index, element) {
        let ids = localStorage.getItem(storageKey) || '[]';
        ids = JSON.parse(ids);
        const $listing = $(element);
        $.ajax({
            url: selectrum.ajax_url,
            type: 'POST',
            data: {
                action: 'get_favourites',
                ids: ids
            },
            success: function (response) {
                $listing.find('.listing__list').append(response.data);
                $('[class*="__likeButton"]').each(updateButton);
            }
        });
    });
});